var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"h-screen pos-relative",on:{"wheel":_vm.onScroll}},[_c('div',{staticClass:"pos-fixed pos-left pos-right z-1",style:({
            transition: `top ${_vm.animationDuration}ms`,
            top: `-${_vm.value * 100}vh`,
        })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }